<app-header></app-header>
<div class="responsive">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>
      <div class="col-md-9">
        <!-- Header Section -->
        <div class="row">
          <div class="col-md-12">
            <div class="section-bar margin-b">
              <button class="icon-btn" title="Back" (click)="goBack()">
                <i class="fas fa-arrow-left"></i>
              </button>
              <div class="section-title">Mentor Manager</div>
              <button class="btn btn-sm section-action" (click)="addMentor(addMentorModal)">
                <i class="fas fa-user-plus"></i> Add Mentor
              </button>
            </div>
          </div>
        </div>

        <!-- Search Section -->
        <div class="row">
          <div class="col-md-12">
            <div class="search-section">
              <div class="search-container">
                <div class="search-icon-wrapper">
                  <i class="fas fa-search search-icon"></i>
                </div>
                <input type="text" 
                       class="search-input" 
                       placeholder="Search mentors by name or email..." 
                       (input)="onMentorSearchChange($event)"
                       [value]="mentorSearchTerm"
                       [class.has-value]="mentorSearchTerm">
                <button class="search-clear-btn" 
                        *ngIf="mentorSearchTerm"
                        type="button" 
                        (click)="mentorSearchTerm = ''; loadMentors(true);"
                        title="Clear search">
                  <i class="fas fa-times"></i>
                </button>
                <div class="search-focus-line"></div>
              </div>
              <div class="search-hint" *ngIf="!mentorSearchTerm">
                <i class="fas fa-info-circle"></i>
                <span>Type to search mentors by name, email, or username</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Mentors List Table -->
        <div class="row">
          <div class="col-md-12">
            <div class="mentor-table-container">
              <!-- Loading State -->
              <div *ngIf="loading && mentorArr.length === 0" class="loading-container">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p class="text-muted mt-3">Loading mentors...</p>
              </div>

              <!-- Empty State -->
              <div *ngIf="!loading && mentorArr?.length === 0" class="empty-state">
                <i class="fas fa-users"></i>
                <h5>No mentors found</h5>
                <p *ngIf="mentorSearchTerm">Try adjusting your search criteria</p>
                <p *ngIf="!mentorSearchTerm">Get started by adding your first mentor</p>
                <button class="btn main-backgroundcolor color mt-3" (click)="addMentor(addMentorModal)">
                  <i class="fas fa-user-plus"></i> Add Mentor
                </button>
              </div>

              <!-- Mentors Table -->
              <div *ngIf="!loading && mentorArr?.length > 0" 
                   class="table-responsive mentor-table-wrapper"
                   (scroll)="onMentorTableScroll($event)">
                <table class="table mentor-table">
                  <thead>
                    <tr>
                      <th>Mentor</th>
                      <th>Email</th>
                      <th>Serving</th>
                      <th>Categories</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let mentor of mentorArr" class="mentor-row">
                      <td>
                        <div class="mentor-info">
                          <img [src]="renderImage(mentor?.user?.photo)" 
                               (error)="getErrorImage($event)"
                               alt="Mentor"
                               class="mentor-avatar">
                          <div class="mentor-name">
                            <strong>{{ getUserDisplayName(mentor?.user) }}</strong>
                            <small class="text-muted d-block" *ngIf="mentor?.user?.userName">
                              @{{ mentor.user.userName }}
                            </small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span class="email-text">{{ mentor?.user?.email || '--' }}</span>
                      </td>
                      <td>
                        <div class="tags-inline">
                          <span class="tag-small" *ngFor="let serve of mentor?.serving">{{ serve }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="tags-inline">
                          <span class="tag-small" *ngFor="let category of mentor?.mentorshipCategory?.slice(0, 2)">
                            {{ category }}
                          </span>
                          <span class="tag-small tag-more" *ngIf="mentor?.mentorshipCategory?.length > 2">
                            +{{ mentor.mentorshipCategory.length - 2 }} more
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="action-buttons">
                          <button class="btn btn-sm btn-view" 
                                  (click)="viewMentor(mentor, viewMentorModal)"
                                  title="View Details">
                            <i class="fas fa-eye"></i>
                          </button>
                          <button class="btn btn-sm btn-edit" 
                                  (click)="editMentor(mentor, addMentorModal)"
                                  title="Edit">
                            <i class="fas fa-edit"></i>
                          </button>
                          <button class="btn btn-sm btn-delete" 
                                  (click)="deleteMentor(mentor)"
                                  title="Delete">
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                
                <!-- Infinite Scroll Loading Indicator -->
                <div *ngIf="loading && mentorArr.length > 0" class="infinite-scroll-loader">
                  <div class="spinner-border spinner-border-sm text-primary" role="status">
                    <span class="sr-only">Loading more...</span>
                  </div>
                  <p class="text-muted small mt-2">Loading more mentors...</p>
                </div>
              </div>

              <!-- Pagination -->
              <div *ngIf="!loading && mentorArr?.length > 0" class="pagination-container">
                <div class="pagination-info">
                  <span>Showing {{ mentorArr.length }} of {{ mentorTotal }} mentors</span>
                  <span *ngIf="mentorSearchTerm" class="text-muted ml-2">
                    (filtered by "{{ mentorSearchTerm }}")
                  </span>
                </div>
                <div class="pagination-controls">
                  <button class="btn btn-sm btn-outline-secondary" 
                          (click)="prevMentorPage()" 
                          [disabled]="mentorSkip === 0">
                    <i class="fas fa-chevron-left"></i> Previous
                  </button>
                  <span class="page-info">
                    Page {{ getCurrentPage() }} of {{ getTotalPages() }}
                  </span>
                  <button class="btn btn-sm btn-outline-secondary" 
                          (click)="nextMentorPage()" 
                          [disabled]="loading || (mentorSkip + mentorLimit) >= mentorTotal">
                    Next <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- View Mentor Details Modal -->
<ng-template #viewMentorModal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color">Mentor Details</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="viewingMentor">
    <div class="mentor-details-view">
      <!-- Profile Section -->
      <div class="detail-section">
        <h6 class="section-title"><i class="fas fa-user"></i> Profile</h6>
        <div class="profile-info">
          <div class="profile-image">
            <img [src]="renderImage(viewingMentor?.user?.photo)" 
                 (error)="getErrorImage($event)"
                 alt="Mentor Photo">
          </div>
          <div class="profile-details">
            <p><strong>Name:</strong> {{ getUserDisplayName(viewingMentor?.user) }}</p>
            <p><strong>Email:</strong> {{ viewingMentor?.user?.email || '--' }}</p>
            <p *ngIf="viewingMentor?.user?.userName">
              <strong>Username:</strong> @{{ viewingMentor.user.userName }}
            </p>
            <p *ngIf="viewingMentor?.profileLink">
              <strong>Profile Link:</strong> 
              <a [href]="viewingMentor.profileLink" target="_blank" class="profile-link">
                {{ viewingMentor.profileLink }} <i class="fas fa-external-link-alt"></i>
              </a>
            </p>
          </div>
        </div>
      </div>

      <!-- Mentorship Details -->
      <div class="detail-section">
        <h6 class="section-title"><i class="fas fa-info-circle"></i> Mentorship Details</h6>
        <p class="mentorship-desc">{{ viewingMentor?.mentorshipDetails || '--' }}</p>
      </div>

      <!-- Serving -->
      <div class="detail-section">
        <h6 class="section-title"><i class="fas fa-users"></i> Serving</h6>
        <div class="tags">
          <span class="tag" *ngFor="let serve of viewingMentor?.serving">{{ serve }}</span>
        </div>
      </div>

      <!-- Mentorship Category -->
      <div class="detail-section">
        <h6 class="section-title"><i class="fas fa-tags"></i> Mentorship Category</h6>
        <div class="tags">
          <span class="tag" *ngFor="let category of viewingMentor?.mentorshipCategory">{{ category }}</span>
        </div>
      </div>

      <!-- Type of Mentorship -->
      <div class="detail-section">
        <h6 class="section-title"><i class="fas fa-handshake"></i> Type of Mentorship</h6>
        <div class="tags">
          <span class="tag" *ngFor="let type of viewingMentor?.mentorshipType">{{ type }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('close')">Close</button>
    <button type="button" class="btn main-backgroundcolor color" (click)="editMentor(viewingMentor, addMentorModal); modal.dismiss('edit')">
      <i class="fas fa-edit"></i> Edit Mentor
    </button>
  </div>
</ng-template>

<!-- Add/Edit Mentor Modal -->
<ng-template #addMentorModal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color">{{ editingMentor ? 'Edit Mentor' : 'Add Mentor' }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="mentorForm">
      <!-- Mentor Profile Selection -->
      <div class="form-group">
        <label>
          <i class="fas fa-user" style="margin-right: 8px; color: #176663;"></i>
          Mentor's Profile <span class="text-danger">*</span>
        </label>
        <div class="input-group">
          <input type="text" class="form-control" 
                 [value]="selectedUser?.name || ''" 
                 placeholder="Choose individual" 
                 readonly 
                 (click)="openUserSelector(userSelectorModal)">
          <div class="input-group-append">
            <button type="button" class="btn main-backgroundcolor color" (click)="openUserSelector(userSelectorModal)">
              <i class="fas fa-search" style="margin-right: 5px;"></i>Select
            </button>
          </div>
        </div>
        <small class="text-muted" *ngIf="!selectedUser" style="display: flex; align-items: center; margin-top: 5px;">
          <i class="fas fa-exclamation-circle" style="margin-right: 5px;"></i>No user selected
        </small>
        <small class="text-success" *ngIf="selectedUser" style="display: flex; align-items: center; margin-top: 5px; font-weight: 600;">
          <i class="fas fa-check-circle" style="margin-right: 5px;"></i>
          Selected: {{ selectedUser.name }} ({{ selectedUser.email }})
        </small>
      </div>

      <!-- Optional Profile Link -->
      <div class="form-group">
        <label>Profile Link (Optional)</label>
        <input type="url" class="form-control" formControlName="profileLink" 
               placeholder="https://ravel.faith/profile/..."
               [class.is-invalid]="submitted && f?.profileLink && f.profileLink.errors && f.profileLink.errors['invalidUrl']">
        <small class="text-muted">Optional link to their Ravel Individual Profile</small>
        <div *ngIf="submitted && f?.profileLink && f.profileLink.errors && f.profileLink.errors['invalidUrl']" class="text-danger small">
          Please enter a valid URL
        </div>
      </div>

      <!-- Mentorship Details -->
      <div class="form-group">
        <label>
          <i class="fas fa-file-alt" style="margin-right: 8px; color: #176663;"></i>
          Mentorship Details <span class="text-danger">*</span>
        </label>
        <textarea class="form-control" 
                  formControlName="mentorshipDetails" 
                  rows="5"
                  placeholder="Enter mentor's biography, qualifications and details (max 500 characters)"
                  [class.is-invalid]="submitted && (f.mentorshipDetails?.invalid || getMentorshipDetailsLength() > 500)"></textarea>
        <div class="d-flex justify-content-between" style="margin-top: 8px;">
          <small class="text-muted">
            <i class="fas fa-info-circle" style="margin-right: 4px;"></i>
            Biography, qualifications and details
          </small>
          <small [class.text-danger]="getMentorshipDetailsLength() > 500" 
                 [class.text-muted]="getMentorshipDetailsLength() <= 500"
                 [class.text-success]="getMentorshipDetailsLength() > 0 && getMentorshipDetailsLength() <= 500"
                 style="font-weight: 600;">
            {{ getMentorshipDetailsLength() }}/500
          </small>
        </div>
        <div *ngIf="submitted && f.mentorshipDetails && f.mentorshipDetails.errors && f.mentorshipDetails.errors['required']" class="text-danger small">
          Mentorship details is required
        </div>
        <div *ngIf="submitted && f.mentorshipDetails && f.mentorshipDetails.errors && f.mentorshipDetails.errors['maxlength']" class="text-danger small">
          Maximum 500 characters allowed
        </div>
      </div>

      <!-- Serving -->
      <div class="form-group">
        <label>
          <i class="fas fa-users" style="margin-right: 8px; color: #176663;"></i>
          Serving <span class="text-danger">*</span> <span class="text-muted" style="font-weight: normal;">(Select at least one)</span>
        </label>
        <div class="checkbox-group">
          <div class="form-check" *ngFor="let option of servingOptions; let i = index">
            <input class="form-check-input" type="checkbox" [formControl]="servingFormArray.at(i)" [id]="'serving' + i">
            <label class="form-check-label" [for]="'serving' + i">
              <i class="fas" [ngClass]="option === 'Men' ? 'fa-mars' : 'fa-venus'" style="color: #176663;"></i>
              <span style="margin-left: 6px;">{{ option }}</span>
            </label>
          </div>
        </div>
        <div *ngIf="submitted && getSelectedServing().length === 0" class="text-danger small" style="margin-top: 8px;">
          <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i>Please select at least one serving option
        </div>
      </div>

      <!-- Mentorship Category -->
      <div class="form-group">
        <label>
          <i class="fas fa-tags" style="margin-right: 8px; color: #176663;"></i>
          Mentorship Category <span class="text-danger">*</span> <span class="text-muted" style="font-weight: normal;">(Select at least one)</span>
        </label>
        <div class="checkbox-group">
          <div class="form-check" *ngFor="let category of mentorshipCategories; let i = index">
            <input class="form-check-input" type="checkbox" [formControl]="categoryFormArray.at(i)" [id]="'category' + i">
            <label class="form-check-label" [for]="'category' + i">
              {{ category }}
            </label>
          </div>
        </div>
        <div *ngIf="submitted && getSelectedCategories().length === 0" class="text-danger small" style="margin-top: 8px;">
          <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i>Please select at least one mentorship category
        </div>
      </div>

      <!-- Type of Mentorship -->
      <div class="form-group">
        <label>
          <i class="fas fa-handshake" style="margin-right: 8px; color: #176663;"></i>
          Type of Mentorship <span class="text-danger">*</span> <span class="text-muted" style="font-weight: normal;">(Select at least one)</span>
        </label>
        <div class="checkbox-group">
          <div class="form-check" *ngFor="let type of mentorshipTypes; let i = index">
            <input class="form-check-input" type="checkbox" [formControl]="typeFormArray.at(i)" [id]="'type' + i">
            <label class="form-check-label" [for]="'type' + i">
              {{ type }}
            </label>
          </div>
        </div>
        <div *ngIf="submitted && getSelectedTypes().length === 0" class="text-danger small" style="margin-top: 8px;">
          <i class="fas fa-exclamation-triangle" style="margin-right: 5px;"></i>Please select at least one mentorship type
        </div>
      </div>

      <div *ngIf="showError" class="alert alert-danger">
        Please fill in all required fields correctly.
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn main-backgroundcolor color" (click)="submitMentor(modal)">{{ editingMentor ? 'Update' : 'Add' }}</button>
  </div>
</ng-template>

<!-- User Selector Modal -->
<ng-template #userSelectorModal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color">Select Mentor Profile</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <div class="input-group">
        <input type="text" 
               class="form-control" 
               placeholder="Search by name or email" 
               (input)="onUserSearchChange($event)"
               [value]="userSearchTerm">
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
        </div>
      </div>
      <small class="text-muted" *ngIf="userSearchTerm">
        Searching for "{{ userSearchTerm }}"
      </small>
    </div>
    
    <div *ngIf="loadingUsers && filteredUsers.length === 0" class="text-center" style="padding: 40px;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="text-muted mt-2">Loading users...</p>
    </div>
    
    <div *ngIf="!loadingUsers && filteredUsers?.length === 0 && userSearchTerm" class="text-center text-muted" style="padding: 40px;">
      <i class="fas fa-search" style="font-size: 48px; opacity: 0.3; margin-bottom: 15px;"></i>
      <p>No users found matching "{{ userSearchTerm }}"</p>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="userSearchTerm = ''; getUserForMentor(true);">
        Clear Search
      </button>
    </div>
    
    <div *ngIf="!loadingUsers && filteredUsers?.length === 0 && !userSearchTerm" class="text-center text-muted" style="padding: 40px;">
      <i class="fas fa-users" style="font-size: 48px; opacity: 0.3; margin-bottom: 15px;"></i>
      <p>No users available</p>
    </div>
    
    <div class="user-list" 
         style="max-height: 400px; overflow-y: auto;"
         (scroll)="onUserListScroll($event)"
         *ngIf="filteredUsers?.length > 0">
      <div *ngFor="let u of filteredUsers" 
           class="card margin-b user-card" 
           (click)="selectUser(u, modal)" 
           style="cursor: pointer;">
        <div class="card-body d-flex align-items-center">
          <img [src]="renderImage(u.photo)" 
               (error)="getErrorImage($event)" 
               alt="" 
               style="width:50px;height:50px;border-radius:50%;object-fit:cover;margin-right:15px;">
          <div class="flex-grow-1">
  <div style="font-weight:600; font-size:16px;">
    {{ getUserDisplayName(u) }}
  </div>

  <div class="text-muted small">
    {{ u.email || '--' }}
  </div>

  <div class="text-muted small"
       *ngIf="u.userName"
       style="font-size:12px;">
    @{{ u.userName }}
  </div>

 
  <div class="text-muted small"
       *ngIf="u?.address?.city"
       style="font-size:12px;">
    <i class="fas fa-map-marker-alt me-1"></i>
    {{ u.address.city }}
  </div>
</div>

<i class="fas fa-check-circle text-success"
   *ngIf="selectedUser?._id === u._id"
   style="font-size:20px;">
</i>
        </div>
      </div>
      
      <!-- Loading indicator for pagination -->
      <div *ngIf="loadingUsers && filteredUsers.length > 0" class="text-center" style="padding: 20px;">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="sr-only">Loading more...</span>
        </div>
        <p class="text-muted small mt-2">Loading more users...</p>
      </div>
      
      <!-- End of list indicator -->
      <div *ngIf="!hasMoreUsers && filteredUsers.length > 0" class="text-center text-muted" style="padding: 15px;">
        <small>No more users to load</small>
      </div>
    </div>
    
    <div *ngIf="filteredUsers.length > 0" class="text-center mt-2">
      <small class="text-muted">
        Showing {{ filteredUsers.length }} of {{ userTotal }} users
      </small>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn main-backgroundcolor color" (click)="modal.close('close')">Close</button>
  </div>
</ng-template>
